<div class="sidebar-left">
  <nav>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ng-content select="[navbarItem]"></ng-content>
    </div>
  </nav>
</div>
